/**
 * Use for REACT ADMIN LIST
 */
import { makeStyles } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import { useFileUpload } from "use-file-upload";
import useUpdateProductImage from "../hooks/useUpdateProductImage";

const useStyles = makeStyles((theme) => ({
  normal: {
    width: 50,
    height: 50,
  },
  big: {
    width: 100,
    height: 100,
  },
  small: {
    width: 20,
    height: 20,
  },
  root: {},
}));

const SFImagefield = ({
  className,
  record,
  source,
  big,
  small,
  normal,
  square,
  productListPage,
}) => {
  const classes = useStyles();
  const { updateProductImage } = useUpdateProductImage();
  const [, selectFile] = useFileUpload();
  const size = big ? classes.big : small ? classes.small : classes.normal;

  const uploadFile = async (file) => {
    //Simple Validate image
    if (file.size > 10000000) {
      alert("File size is too big");
      return;
    }

    const [result, error] = await updateProductImage({
      productId: record.id,
      version: record.__v,
      image: file,
    });

    if (error) alert(error.message);
    if (result) window.location.reload();
  };

  if (productListPage)
    return (
      <Avatar
        src={record[source]}
        variant={square ? "square" : "rounded"}
        className={[classes.root, size, className]}
        onClick={(e) => {
          e.stopPropagation();
          selectFile({}, ({ source, name, size, file }) => {
            // file - is the raw File Object

            uploadFile(file);
          });
        }}
      ></Avatar>
    );

  return (
    <Avatar
      src={record[source]}
      variant={square ? "square" : "rounded"}
      className={[classes.root, size, className]}
    />
  );
};

export default SFImagefield;
